'use strict';

var ChartFbcApplicabailityLegendController = function ChartFbcApplicabailityLegendController($scope, chartFbcApplicabilityService) {
  $scope.timePeriod = '';
  $scope.updateTimePeriod = function (from, to) {
    $scope.timePeriod = chartFbcApplicabilityService.getTimePeriodString(from, to);
  };
};
ChartFbcApplicabailityLegendController.$inject = ['$scope', 'ChartFbcApplicabilityService'];
module.exports = ChartFbcApplicabailityLegendController;